import { APP_BASE_HREF } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { BrowserModule } from '@angular/platform-browser'
import { provideEffects } from '@ngrx/effects'
import { provideStore } from '@ngrx/store'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsCodeModule } from 'se-fe-docs-code'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeDocsTableModule } from 'se-fe-docs-table'
import { SeFeFormFieldModule } from 'se-fe-form-field'
import { SeFeGridModule } from 'se-fe-grid'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFeIconModule, seFeIconMenu } from 'se-fe-icon'
import { SeFeLeftNavModule } from 'se-fe-left-nav'
import { SeFePageModule } from 'se-fe-page'
import { SeFeSwitchModule } from 'se-fe-switch'
import { SeFeToastModule } from 'se-fe-toast'
import { SeFeTranslationsModule } from 'se-fe-translations'

import { environment } from '@se-po/shared-environments'

import { AppDocIframeComponent } from './app-doc-iframe/app-doc-iframe.component'
import { AppComponent } from './app.component'
import { DocsAppRoutingModule } from './docs-app-routing.module'
import { HomeComponent } from './home/home.component'
import { SeHouseholdSetupDocsModule } from './se-household-setup-docs/se-household-setup-docs.module'
import { SeMissingPersonaInfoDocsModule } from './se-missing-persona-info-docs/se-missing-persona-info-docs.module'
import { SharedDocsModule } from './shared-docs/shared-docs.module'

@NgModule({
  declarations: [
    AppComponent,
    AppDocIframeComponent,
    HomeComponent
  ],
  imports: [
    BrowserModule,
    DocsAppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeButtonModule,
    SeFeCardModule,
    SeFeDocsCodeModule,
    SeFeDocsExampleModule,
    SeFeDocsTableModule,
    SeFeFormFieldModule,
    SeFeGridModule,
    SeFeHeaderModule,
    SeFeIconModule.include([seFeIconMenu]),
    SeFeLeftNavModule,
    SeFePageModule,
    SeFeSwitchModule,
    SeFeToastModule,
    SeHouseholdSetupDocsModule,
    SeMissingPersonaInfoDocsModule,
    SharedDocsModule,
    SeFeTranslationsModule.forRoot(['en', 'en-gb'], environment.local ? '/docs' : `${environment.baseUrl}/docs`),
  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/docs/' },
    provideStore(),
    provideEffects([])
  ],
  bootstrap: [AppComponent],
  exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
